import React, {/* useState */} from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar, // Badge,
  Box, IconButton, Toolbar, Tooltip
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import MenuIcon from '@mui/icons-material/Menu';
// import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import ExitIcon from '@mui/icons-material/ExitToAppOutlined';
import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlined from '@mui/icons-material/LightModeOutlined';
import LogoMini from 'src/components/LogoMini';
import tokenService from 'src/services/token.service';
import { dashboard, root } from 'src/utils/appRoutes';
import { useThemeMode } from 'src/contexts/ThemeModeContext';

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    width: 60,
    height: 60
  }
}));

const TopBar = ({
  className,
  onMobileNavOpen,
  setIsAuth,
  ...rest
}) => {
  const classes = useStyles();
  // const [notifications] = useState([]);
  const { mode, toggleMode } = useThemeMode();
  const navigate = useNavigate();
  const exitApp = () => {
    tokenService.logOut();
    setIsAuth(false);
    navigate(root(), { replace: true });
  };

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      {...rest}
    >
      <Toolbar>
        <Box
          sx={{
            display: { xs: 'none', lg: 'flex' },
            alignItems: 'center',
            pl: 1,
            pr: 2
          }}
        >
          <RouterLink
            to={dashboard()}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 48,
                height: 48,
                borderRadius: '50%',
                border: '2px solid',
                borderColor: 'rgba(255, 255, 255, 0.6)'
              }}
            >
              <LogoMini style={{ height: 30 }} />
            </Box>
          </RouterLink>
        </Box>
        <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
          <IconButton color="inherit" onClick={onMobileNavOpen} size="large">
            <MenuIcon />
          </IconButton>
        </Box>
        <Box sx={{
          flexGrow: 1
        }}
        />
        {/* <IconButton color="inherit">
          <Badge
            badgeContent={notifications.length}
            color="primary"
            variant="dot"
          >
            <NotificationsIcon />
          </Badge>
        </IconButton> */}
        <Tooltip title={mode === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}>
          <IconButton color="inherit" onClick={toggleMode} size="large">
            {mode === 'dark' ? <LightModeOutlined /> : <DarkModeOutlined />}
          </IconButton>
        </Tooltip>
        <IconButton color="inherit" onClick={exitApp} size="large">
          <ExitIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
  setIsAuth: PropTypes.func
};

export default TopBar;
